// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Unscramble from "../Unscramble/index.js";
var SerializedMap = function (x) {
    return x;
};
var AsJSONKeyString = (function () {
    function AsJSONKeyString(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AsJSONKeyString.create = function (value0) {
        return function (value1) {
            return new AsJSONKeyString(value0, value1);
        };
    };
    return AsJSONKeyString;
})();
var AsJSONKeyValue = (function () {
    function AsJSONKeyValue(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AsJSONKeyValue.create = function (value0) {
        return function (value1) {
            return new AsJSONKeyValue(value0, value1);
        };
    };
    return AsJSONKeyValue;
})();
var udecodeMap = function (dictOrd) {
    return function (dictFromJSONKey) {
        return function (dictDecode) {
            return Unscramble.decode_Map(dictFromJSONKey)(dictOrd)(dictDecode);
        };
    };
};
var showMap = function (dictShow) {
    return function (dictShow1) {
        return Data_Map_Internal.showMap(dictShow)(dictShow1);
    };
};
var semigroupMap = function (dictOrd) {
    return {
        append: function (v) {
            return function (v1) {
                return Data_Map_Internal.union(dictOrd)(v)(v1);
            };
        }
    };
};
var ordMap = function (dictOrd) {
    return function (dictOrd1) {
        return Data_Map_Internal.ordMap(dictOrd)(dictOrd1);
    };
};
var newtypeMap = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidMap = function (dictOrd) {
    return {
        mempty: Data_Map_Internal.empty,
        Semigroup0: function () {
            return semigroupMap(dictOrd);
        }
    };
};
var functorMap = Data_Map_Internal.functorMap;
var fromJSONKeyMap = function (dictOrd) {
    return function (dictFromJSONKey) {
        return function (dictDecode) {
            return {
                fromJSONKey: Unscramble.defaultFromJSONKeyValue(udecodeMap(dictOrd)(dictFromJSONKey)(dictDecode))
            };
        };
    };
};
var foldableWithIndexMap = Data_Map_Internal.foldableWithIndexMap;
var foldableMap = Data_Map_Internal.foldableMap;
var eqMap = function (dictEq) {
    return function (dictEq1) {
        return Data_Map_Internal.eqMap(dictEq)(dictEq1);
    };
};
var asJSONKeyString = {
    asJSONKey: new AsJSONKeyString(Control_Category.identity(Control_Category.categoryFn), Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity)))
};
var asJSONKey = function (dict) {
    return dict.asJSONKey;
};
var decodeMap = function (dictOrd) {
    return function (dictAsJSONKey) {
        return function (dictDecode) {
            return {
                decode: function (f) {
                    var v = asJSONKey(dictAsJSONKey);
                    if (v instanceof AsJSONKeyString) {
                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.objectDecode(dictDecode))(f))(function (obj) {
                            var kvs = Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray)(obj);
                            return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))((function () {
                                var $58 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
                                return function ($59) {
                                    return SerializedMap($58($59));
                                };
                            })())(Data_Traversable.traverse(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(function (v1) {
                                return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Function.flip(Data_Tuple.Tuple.create)(v1.value1))(v.value1(v1.value0));
                            })(kvs));
                        });
                    };
                    if (v instanceof AsJSONKeyValue) {
                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(Data_Tuple_T2.decodeT2(Foreign_Generic_Class.foreignDecode)(dictDecode)))(f))(function (kvs) {
                            return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))((function () {
                                var $60 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
                                return function ($61) {
                                    return SerializedMap($60($61));
                                };
                            })())(Data_Traversable.traverse(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(function (v1) {
                                return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Function.flip(Data_Tuple.Tuple.create)(v1.value1))(v.value1(v1.value0));
                            })(kvs));
                        });
                    };
                    throw new Error("Failed pattern match at Data.Map.Serialized (line 53, column 5 - line 60, column 105): " + [ v.constructor.name ]);
                }
            };
        };
    };
};
var encodeMap = function (dictAsJSONKey) {
    return function (dictEncode) {
        return {
            encode: function (v) {
                var kvs = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(v);
                var v1 = asJSONKey(dictAsJSONKey);
                if (v1 instanceof AsJSONKeyString) {
                    return Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(dictEncode))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(function (v2) {
                        return new Data_Tuple.Tuple(v1.value0(v2.value0), v2.value1);
                    })(kvs)));
                };
                if (v1 instanceof AsJSONKeyValue) {
                    return Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(Data_Tuple_T2.encodeT2(Foreign_Generic_Class.foreignEncode)(dictEncode)))(Data_Functor.map(Data_Functor.functorArray)(function (v2) {
                        return new Data_Tuple_T2.T2(v1.value0(v2.value0), v2.value1);
                    })(kvs));
                };
                throw new Error("Failed pattern match at Data.Map.Serialized (line 47, column 5 - line 49, column 107): " + [ v1.constructor.name ]);
            }
        };
    };
};
var asJSONKeyMap = function (dictOrd) {
    return function (dictAsJSONKey) {
        return function (dictEncode) {
            return function (dictDecode) {
                return {
                    asJSONKey: new AsJSONKeyValue(Foreign_Generic_Class.encode(encodeMap(dictAsJSONKey)(dictEncode)), Foreign_Generic_Class.decode(decodeMap(dictOrd)(dictAsJSONKey)(dictDecode)))
                };
            };
        };
    };
};
export {
    SerializedMap,
    asJSONKey,
    AsJSONKeyString,
    AsJSONKeyValue,
    newtypeMap,
    eqMap,
    ordMap,
    showMap,
    semigroupMap,
    monoidMap,
    functorMap,
    foldableMap,
    udecodeMap,
    foldableWithIndexMap,
    asJSONKeyString,
    asJSONKeyMap,
    encodeMap,
    decodeMap,
    fromJSONKeyMap
};
//# sourceMappingURL=index.js.map
